import { useMutation } from "@tanstack/react-query";
import api from "apis";

export const useAddOrGetFreeTagMutation = () => {
  return useMutation({ mutationFn: api.document.addOrGetFreeTag });
};
